/* eslint-disable @typescript-eslint/dot-notation */

import type { RefObject, FC } from 'react';
import { useAppConfig } from '@tmsw/powerups.config.app.provider';
import { processLocaleKeys } from '@tmsw/powerups.intl.hooks.use-process-locale-keys';
import type { ProcessLocaleKeysOptions } from '@tmsw/powerups.intl.hooks.use-process-locale-keys';
import type {
  ListItemPropsOptions,
  ListItemVariantProps,
} from './OptionsMenuListItem';

export type OptionsMenuListItems = ListItemVariantProps<any>[];

export type SettingsConfig = {
  root: {
    name: string;
    heading: string;
    component: FC<any>;
    items: OptionsMenuListItems;
    options: Partial<ListItemPropsOptions> & ProcessLocaleKeysOptions;
  };
};

export const parseSettingsConfig = (
  config: SettingsConfig,
  additionalOptions
): SettingsConfig => {
  config.root.options = { ...config.root.options, ...additionalOptions };
  config.root = processLocaleKeys(config.root, config.root.options);
  config.root.items = config.root.items.map(
    (itemData: ListItemVariantProps<any>) => {
      return {
        ...{
          // @ts-ignore
          shouldRender: () => true,
          ...itemData,
          ...processLocaleKeys(itemData, config.root.options),
        },
      };
    }
  );
  return config;
};

export function useSettingsConfig(
  options: ListItemPropsOptions
): SettingsConfig {
  const appConfig = useAppConfig();
  const configRef: RefObject<SettingsConfig> = {
    current: parseSettingsConfig(appConfig.components.SettingsPanel, options),
  };
  return configRef.current!;
}

export default useSettingsConfig;
